export const fileExtensionsMapper: any = {
  pdf: "PDF",
  exe: "EXE File",
  ifc: "IFC File",
  doc: "Microsoft Word Document",
  docx: "Microsoft Word Document",
  xls: "Microsoft Excel Document",
  xlsx: "Microsoft Excel Document",
  ppt: "Microsoft PowerPoint Document",
  pptx: "Microsoft PowerPoint Document",
  txt: "TXT File",
  jpg: "JPG File",
  jpeg: "JPEG File",
  png: "PNG File",
};
